import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * PATCH /system/user/me/password
 * `currentPassword`／`newPassword` 須已為 MD5 hex。
 * @see docs/API_SYSTEM_USER.md § Change own password
 */
export async function changeOwnPassword({ currentPassword, newPassword }) {
  const { data: raw } = await request.patch(
    '/system/user/me/password',
    keysToSnake({ currentPassword, newPassword }),
  );
  return parseVer4DetailResponse(raw);
}
